import { formatDateHuman, parseDateISO } from "../date-utils";
export const qualityDocumentVersionFields = [{
        name: "name",
        title: "Nome",
        render: (record) => record.name
    }, {
        name: "version",
        title: "Versione",
        render: (record) => record.version
    }, {
        name: "notes",
        title: "Note",
        render: (record) => record.notes
    }, {
        name: "documentDate",
        title: "Data",
        render: (record) => formatDateHuman(parseDateISO(record.documentDate))
    }];
export const qualityDocumentFields = [{
        name: "name",
        title: "Nome",
        render: (record) => record.name
    }, {
        name: "notes",
        title: "Note",
        render: (record) => record.notes
    }, {
        name: "documentDate",
        title: "Data",
        render: (record) => formatDateHuman(parseDateISO(record.documentDate))
    }];
